var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.57502 3.21659L1.51668 14.9999C1.37116 15.2519 1.29416 15.5377 1.29334 15.8287C1.29253 16.1197 1.36793 16.4059 1.51204 16.6587C1.65615 16.9115 1.86396 17.1222 2.11477 17.2698C2.36559 17.4174 2.65068 17.4967 2.94168 17.4999H17.0583C17.3494 17.4967 17.6344 17.4174 17.8853 17.2698C18.1361 17.1222 18.3439 16.9115 18.488 16.6587C18.6321 16.4059 18.7075 16.1197 18.7067 15.8287C18.7059 15.5377 18.6289 15.2519 18.4834 14.9999L11.425 3.21659C11.2765 2.97168 11.0673 2.76919 10.8177 2.62866C10.5681 2.48813 10.2865 2.41431 10 2.41431C9.71357 2.41431 9.43196 2.48813 9.18235 2.62866C8.93275 2.76919 8.72358 2.97168 8.57502 3.21659V3.21659Z",
    stroke: "#FFB800",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 7.5V10.8333",
    stroke: "#FFB800",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 14.1667H10.0083",
    stroke: "#FFB800",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.ed494e89b385de50949ff1527153590d.svg";
export { ForwardRef as ReactComponent };